(() => {
  const ns = 'http://www.w3.org/2000/svg';
  function element(tag, attrs = {}) {
    const node = document.createElementNS(ns, tag);
    Object.entries(attrs).forEach(([key,value]) => node.setAttribute(key, value));
    return node;
  }
  function projection(source, width, height) {
    const target = [[0,0],[width,0],[width,height],[0,height]];
    const matrix = [], result = [];
    source.forEach(([x,y],i) => {
      const [u,v] = target[i];
      matrix.push([x,y,1,0,0,0,-u*x,-u*y]); result.push(u);
      matrix.push([0,0,0,x,y,1,-v*x,-v*y]); result.push(v);
    });
    for (let c=0;c<8;c++) {
      let pivot=c;
      for(let r=c+1;r<8;r++) if(Math.abs(matrix[r][c])>Math.abs(matrix[pivot][c])) pivot=r;
      [matrix[c],matrix[pivot]]=[matrix[pivot],matrix[c]];
      [result[c],result[pivot]]=[result[pivot],result[c]];
      const divisor=matrix[c][c];
      if(Math.abs(divisor)<1e-10) return null;
      for(let j=c;j<8;j++) matrix[c][j]/=divisor;
      result[c]/=divisor;
      for(let r=0;r<8;r++) if(r!==c) {
        const factor=matrix[r][c];
        for(let j=c;j<8;j++) matrix[r][j]-=factor*matrix[c][j];
        result[r]-=factor*result[c];
      }
    }
    const h=result;
    return 'matrix3d('+[h[0],h[3],0,h[6],h[1],h[4],0,h[7],0,0,1,0,h[2],h[5],0,1].join(',')+')';
  }
  function frame(data, box, id) {
    let width=box?.[2], height=box?.[3];
    if(data.quad) {
      const q=data.quad;
      width=(Math.hypot(q[1][0]-q[0][0],q[1][1]-q[0][1])+Math.hypot(q[2][0]-q[3][0],q[2][1]-q[3][1]))/2;
      height=(Math.hypot(q[3][0]-q[0][0],q[3][1]-q[0][1])+Math.hypot(q[2][0]-q[1][0],q[2][1]-q[1][1]))/2;
    }
    const svg=element('svg',{viewBox:[-8,-8,width+16,height+16].join(' '),preserveAspectRatio:'xMidYMid meet','aria-hidden':'true',class:'yp-catalog-artwork'});
    svg.append(element('rect',{x:-6,y:-6,width:width+12,height:height+12,fill:'#181a17'}));
    const url=new URL(data.url,location.origin);
    url.searchParams.set('width','1440');
    if(data.quad) {
      const transform=projection(data.quad,width,height);
      if(!transform) return svg;
      const foreign=element('foreignObject',{x:0,y:0,width,height});
      const clip=document.createElement('div');
      clip.style.cssText='position:relative;overflow:hidden;width:'+width+'px;height:'+height+'px;';
      const image=document.createElement('img');
      image.alt='';image.src=url.href;image.decoding='async';image.loading='lazy';
      image.style.cssText='position:absolute;left:0;top:0;max-width:none;width:'+data.w+'px;height:'+data.h+'px;transform-origin:0 0;transform:'+transform+';';
      clip.append(image);foreign.append(clip);svg.append(foreign);
    } else {
      const clipId='PlainArtwork-'+id;
      const defs=element('defs');
      const path=element('clipPath',{id:clipId});
      path.append(element('rect',{x:0,y:0,width,height}));defs.append(path);svg.append(defs);
      const group=element('g',{'clip-path':'url(#'+clipId+')'});
      group.append(element('image',{href:url.href,x:-box[0],y:-box[1],width:data.w,height:data.h,preserveAspectRatio:'none'}));
      svg.append(group);
    }
    return svg;
  }
  window.YPPlainArtwork = {
    load(url) {return fetch(url).then(response=>{if(!response.ok)throw new Error('Artwork data unavailable');return response.json();});},
    renderHero(root,map) {
      root.querySelectorAll('[data-hero-product-id]').forEach(link => {
        const data=map[link.dataset.heroProductId];
        if(!data || data.parts || link.dataset.artworkReady || link.dataset.heroFramed==='true') return;
        link.replaceChildren(frame(data,data.box,'hero-'+link.dataset.heroProductId));
        link.dataset.artworkReady='true';
      });
    },
    render(root,map) {
      root.querySelectorAll('.yp-category-card').forEach(card=>{
        const id=card.querySelector('[data-product-id]')?.dataset.productId;
        const media=card.querySelector('.yp-category-card__media');
        if(!media || media.dataset.artworkReady) return;
        const data=map[id];
        if(!data) {
          // Keep the listing image for artwork without a legacy crop mapping.
          const image=media.querySelector('img');
          if(image) {
            image.style.visibility='visible';
            image.style.width='100%';
            image.style.height='100%';
            image.style.objectFit='contain';
          }
          media.dataset.artworkReady='true';
          return;
        }
        if(data.parts) {
          const bundle=document.createElement('span');bundle.className='yp-catalog-artwork-bundle';
          data.parts.forEach((part,i)=>bundle.append(frame(data,part,id+'-'+i)));
          media.replaceChildren(bundle);
        } else media.replaceChildren(frame(data,data.box,id));
        media.dataset.artworkReady='true';
      });
    }
  };
})();


